<vdr-card>
  <vdr-form-field [label]="'Banner Layout'" class="mb-2">
    <select [formControl]="bannerTypeControl">
      <option disabled>Select A Banner Layout</option>
      <option value="left-media-right-text">Left Media Right Text</option>
      <option value="left-text-right-media">Left Text Right Media</option>
      <option value="top-text-below-media">Top Text Below Media</option>
      <option value="media-only">Media Only</option>
      <option value="left-media-slide-with-background">Left Media Slide with Background (deprecated)</option>
      <option value="right-media-slide-with-background">Right Media Slide with Background (deprecated)</option>
      <option value="titled-media">Titled Media (deprecated)</option>
      <option value="text-only">Text Only</option>
      <option value="dual-text">Dual Text</option>
      <option value="middle-media-sides-text">Dual Text With Center Media</option>
    </select>
  </vdr-form-field>

  <hr />

  <p><strong>Background</strong></p>
  <div class="clr-row mt-1">
    <div class="clr-col-12">
      <vdr-form-field [label]="'Background Color'" class="mb-2">
        <input type="color" [formControl]="backgroundColorControl">
      </vdr-form-field>

      <ng-container *ngIf="['left-media-right-text',
          'left-text-right-media',
          'left-media-slide-with-background',
          'right-media-slide-with-background',
          'text-only',
          'dual-text',
          'middle-media-sides-text'
        ].includes(bannerTypeControl.value)">

        <vdr-form-field [label]="'Background Asset'" class="mb-2">
          <vdr-dynamic-form-input #backgroundMediaInput
            [control]="backgroundMediaControl"
            [def]="{ type: 'relation', entity: 'Asset', ui: { component: 'relation-form-input' } }">
          </vdr-dynamic-form-input>
        </vdr-form-field>

        <vdr-form-field [label]="'Mobile Background Asset'" class="mb-2">
          <vdr-dynamic-form-input #backgroundMobileMediaInput
            [control]="backgroundMobileMediaControl"
            [def]="{ type: 'relation', entity: 'Asset', ui: { component: 'relation-form-input' } }">
          </vdr-dynamic-form-input>
        </vdr-form-field>

        <vdr-form-field [label]="'Background Media Overlay Opacity (0-1)'" class="mb-2">
          <input type="number" [formControl]="overlayOpacityControl" min="0" max="1" step="0.1">
        </vdr-form-field>
      </ng-container>
    </div>
  </div>

  <hr />

  <ng-container *ngIf="!['text-only', 'dual-text'].includes(bannerTypeControl.value)">
    <p><strong>Foreground Media</strong></p>
    <div class="clr-row mt-1 mb-2">
      <div class="clr-col-6">
        <vdr-form-field [label]="'Media Display Height (px)'">
          <input type="number" [formControl]="mediaHeightControl" placeholder="e.g. 500">
        </vdr-form-field>
      </div>
      <div class="clr-col-6">
        <vdr-form-field [label]="'Media Display Rounded Corners'">
          <select [formControl]="mediaRoundedCornersControl">
            <option value="none">None</option>
            <option value="small">Small</option>
            <option value="medium">Medium</option>
            <option value="large">Large</option>
            <option value="full">Full</option>
          </select>
        </vdr-form-field>
      </div>
    </div>

    <vdr-form-field [label]="'Assets'" class="mb-2">
      <vdr-dynamic-form-input #mediasInput
        [control]="mediasControl"
        [def]="{ list: true, type: 'relation', entity: 'Asset', ui: { component: 'relation-form-input' } }">
      </vdr-dynamic-form-input>
    </vdr-form-field>

    <vdr-form-field [label]="'Mobile Assets'" class="mb-2">
      <vdr-dynamic-form-input #mobileMediasInput
        [control]="mobileMediasControl"
        [def]="{ list: true, type: 'relation', entity: 'Asset', ui: { component: 'relation-form-input' } }">
      </vdr-dynamic-form-input>
    </vdr-form-field>

    <hr />
  </ng-container>

  <ng-container *ngIf="['left-media-right-text',
      'left-text-right-media',
      'top-text-below-media',
      'text-only',
      'dual-text',
      'middle-media-sides-text',
      'titled-media'
    ].includes(bannerTypeControl.value)">

    <p><strong>Content & Typography</strong></p>

    <vdr-form-field [label]="'Text Color'" class="mt-1 mb-2">
      <input type="color" [formControl]="textColorControl">
    </vdr-form-field>
    <vdr-form-field [label]="'Text Bar Style'" *ngIf="bannerTypeControl.value === 'text-only'" class="mb-2">
      <select [formControl]="textBarStyleControl">
        <option value="none">None</option>
        <option value="left">Left</option>
        <option value="right">Right</option>
      </select>
    </vdr-form-field>
    <hr *ngIf="['dual-text', 'middle-media-sides-text'].includes(bannerTypeControl.value)" style="border-top-style: dashed; opacity: 0.5;" />
    <p *ngIf="['dual-text', 'middle-media-sides-text'].includes(bannerTypeControl.value)" class="mb-2"><em>Column 1</em></p>
    <vdr-form-field [label]="['dual-text', 'middle-media-sides-text'].includes(bannerTypeControl.value)? 'Alignment Column 1' : 'Alignment'" class="mb-2">
      <select [formControl]="textAlignmentControl">
        <option value="left">Left</option>
        <option value="center">Center</option>
        <option value="right">Right</option>
      </select>
    </vdr-form-field>
    <vdr-form-field [label]="['dual-text', 'middle-media-sides-text'].includes(bannerTypeControl.value)? 'Title Column 1' : 'Title'" class="mb-2">
      <vdr-dynamic-form-input [control]="titleControl" [def]="titleTextValueDef"></vdr-dynamic-form-input>
    </vdr-form-field>

    <div class="clr-row mb-2">
      <div class="clr-col-6"><vdr-form-field [label]="'Title Font Size (px)'"><input type="number" [formControl]="titleFontSizeControl" min="10"></vdr-form-field></div>
      <div class="clr-col-6"><vdr-form-field [label]="'Title Indentation (px)'"><input type="number" [formControl]="titleIndentationControl" min="0"></vdr-form-field></div>
    </div>

    <ng-container *ngIf="!['titled-media'].includes(bannerTypeControl.value)">
      <vdr-form-field [label]="['dual-text', 'middle-media-sides-text'].includes(bannerTypeControl.value)? 'Body Text Column 1' : 'Body Text'" class="mb-2">
        <vdr-dynamic-form-input [control]="textControl" [def]="textTextValueDef"></vdr-dynamic-form-input>
      </vdr-form-field>

      <div class="clr-row mb-2">
        <div class="clr-col-6"><vdr-form-field [label]="'Body Text Font Size (px)'"><input type="number" [formControl]="textFontSizeControl" min="10"></vdr-form-field></div>
        <div class="clr-col-6"><vdr-form-field [label]="'Body Text Indentation (px)'"><input type="number" [formControl]="textIndentationControl" min="0"></vdr-form-field></div>
      </div>
      <div class="clr-row mb-2">
        <div class="clr-col-6">
          <vdr-form-field [label]="'Body Text Max Width (0-1)'"><input type="number" [formControl]="textWidthControl" min="0" max="1" step="0.01"></vdr-form-field>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="['dual-text', 'middle-media-sides-text'].includes(bannerTypeControl.value)">
      <hr class="mt-2" style="border-top-style: dashed; opacity: 0.5;" />
      <p class="mb-2"><em>Column 2</em></p>

      <vdr-form-field [label]="'Alignment Column 2'" class="mt-1 mb-2">
        <select [formControl]="secColTextAlignmentControl">
          <option value="left">Left</option>
          <option value="center">Center</option>
          <option value="right">Right</option>
        </select>
      </vdr-form-field>

      <vdr-form-field [label]="'Title Column 2'" class="mb-2">
        <vdr-dynamic-form-input [control]="secColTitleControl" [def]="secColTitleTextValueDef"></vdr-dynamic-form-input>
      </vdr-form-field>

      <div class="clr-row mb-2">
        <div class="clr-col-6"><vdr-form-field [label]="'Title Font Size (px)'"><input type="number" [formControl]="secColTitleFontSizeControl" min="10"></vdr-form-field></div>
        <div class="clr-col-6"><vdr-form-field [label]="'Title Indentation (px)'"><input type="number" [formControl]="secColTitleIndentationControl" min="0"></vdr-form-field></div>
      </div>

      <vdr-form-field [label]="'Body Text Column 2'" class="mb-2">
        <vdr-dynamic-form-input [control]="secColTextControl" [def]="secColTextTextValueDef"></vdr-dynamic-form-input>
      </vdr-form-field>

      <div class="clr-row mb-2">
        <div class="clr-col-6"><vdr-form-field [label]="'Body Text Font Size (px)'"><input type="number" [formControl]="secColTextFontSizeControl" min="10"></vdr-form-field></div>
        <div class="clr-col-6"><vdr-form-field [label]="'Body Text Indentation (px)'"><input type="number" [formControl]="secColTextIndentationControl" min="0"></vdr-form-field></div>
      </div>
      <div class="clr-row mb-2">
        <div class="clr-col-6">
          <vdr-form-field [label]="'Body Text Max Width (0-1)'"><input type="number" [formControl]="secColTextWidthControl" min="0" max="1" step="0.01"></vdr-form-field>
        </div>
      </div>
    </ng-container>

    <hr />
  </ng-container>

  <ng-container *ngIf="!['text-only', 'dual-text'].includes(bannerTypeControl.value)">
    <p><strong>Styles</strong></p>
    <div class="clr-row mb-2">
      <div class="clr-col-6">
        <vdr-form-field [label]="'Auto Slide Delay (seconds)'">
          <input type="number" [formControl]="autoSlideDelayControl" step="0.1">
        </vdr-form-field>
      </div>
    </div>

    <div class="clr-row mb-2">
      <div class="clr-col-6">
        <vdr-form-field [label]="bannerTypeControl.value === 'middle-media-sides-text' ? 'Middle Media Ratio' : 'Left Right Ratio'">
          <input type="number" [formControl]="leftRightPartRatioControl">
        </vdr-form-field>
      </div>
      <div class="clr-col-6" *ngIf="['left-media-right-text', 'left-text-right-media'].includes(bannerTypeControl.value)">
        <vdr-form-field [label]="'Left Right Gap (px)'">
          <input type="number" [formControl]="mediaTextGapControl">
        </vdr-form-field>
      </div>
    </div>

    <div class="clr-row mb-2" *ngIf="['left-media-right-text', 'left-text-right-media'].includes(bannerTypeControl.value)">
      <div class="clr-col-6">
        <vdr-form-field [label]="'Mobile Layout Style'">
          <select [formControl]="layoutStyleControl">
            <option value="grid">Responsive</option>
            <option value="normal">Fixed Style 1</option>
          </select>
        </vdr-form-field>
      </div>
    </div>

    <div class="clr-row mb-2">
      <div class="clr-col-6" *ngIf="(layoutStyleControl.value === 'grid') || ['left-media-slide-with-background', 'right-media-slide-with-background'].includes(bannerTypeControl.value)">
        <vdr-form-field [label]="'Mobile Media Position'">
          <select [formControl]="mobileMediaPositionControl">
            <option value="top">Top</option>
            <option value="bottom">Below</option>
          </select>
        </vdr-form-field>
      </div>
      <div class="clr-col-6" *ngIf="((layoutStyleControl.value === 'grid') && ['left-media-right-text', 'left-text-right-media'].includes(bannerTypeControl.value)) || ['top-text-below-media', 'titled-media', 'media-only'].includes(bannerTypeControl.value)">
        <vdr-form-field [label]="'Mobile Media Display Style'">
          <select [formControl]="mobileMediaStyleControl">
            <option value="slide">Slide</option>
            <option value="tiles">Tiles</option>
          </select>
        </vdr-form-field>
      </div>
    </div>

    <hr />
  </ng-container>

  <ng-container *ngIf="bannerTypeControl.value !== 'text-only'">
    <p><strong>Button</strong></p>
    <div class="mt-1 mb-2">
      <vdr-dynamic-form-input
          [control]="buttonControl"
          [def]="buttonInputDef"
      >
      </vdr-dynamic-form-input>
    </div>

    <ng-container *ngIf="marketingBannerData?.button?.enabled">
      <div class="clr-row mb-2">
        <div class="clr-col-4">
          <vdr-form-field [label]="'Button Position'">
            <select [formControl]="buttonPositionControl">
              <option *ngIf="['left-media-right-text', 'left-text-right-media'].includes(bannerTypeControl.value)" value="below-text">Below Text</option>
              <option *ngIf="['dual-text', 'middle-media-sides-text'].includes(bannerTypeControl.value)" value="below-left-text">Below Left Text</option>
              <option *ngIf="['dual-text', 'middle-media-sides-text'].includes(bannerTypeControl.value)" value="below-right-text">Below Right Text</option>
              <option value="custom">Custom Coordinates</option>
            </select>
          </vdr-form-field>
        </div>

        <div class="clr-col-4" *ngIf="['below-text', 'below-left-text', 'below-right-text'].includes(buttonPositionControl.value)">
          <vdr-form-field [label]="'Button Alignment'">
            <select [formControl]="buttonAlignmentControl">
              <option value="left">Left</option>
              <option value="center">Center</option>
              <option value="right">Right</option>
            </select>
          </vdr-form-field>
        </div>

        <ng-container *ngIf="buttonPositionControl.value === 'custom'">
          <div class="clr-col-4"><vdr-form-field [label]="'Button X-Position (0-1)'"><input type="number" [formControl]="buttonLocationXControl" min="0" max="1" step="0.01"></vdr-form-field></div>
          <div class="clr-col-4"><vdr-form-field [label]="'Button Y-Position (0-1)'"><input type="number" [formControl]="buttonLocationYControl" min="0" max="1" step="0.01"></vdr-form-field></div>
        </ng-container>
      </div>

      <div class="clr-row">
        <div class="clr-col-4">
          <vdr-form-field [label]="'Mobile Button Position'">
            <select [formControl]="buttonPositionMobileControl">
              <option *ngIf="['left-media-right-text', 'left-text-right-media', 'middle-media-sides-text', 'dual-text'].includes(bannerTypeControl.value)" value="below-text">Below Text</option>
              <option value="custom">Custom Coordinates</option>
            </select>
          </vdr-form-field>
        </div>

        <div class="clr-col-4" *ngIf="buttonPositionMobileControl.value === 'below-text'">
          <vdr-form-field [label]="'Mobile Button Alignment'">
            <select [formControl]="buttonAlignmentMobileControl">
              <option value="left">Left</option>
              <option value="center">Center</option>
              <option value="right">Right</option>
            </select>
          </vdr-form-field>
        </div>

        <ng-container *ngIf="buttonPositionMobileControl.value === 'custom'">
          <div class="clr-col-4"><vdr-form-field [label]="'Mobile Button X-Position (0-1)'"><input type="number" [formControl]="buttonLocationXMobileControl" min="0" max="1" step="0.01"></vdr-form-field></div>
          <div class="clr-col-4"><vdr-form-field [label]="'Mobile Button Y-Position (0-1)'"><input type="number" [formControl]="buttonLocationYMobileControl" min="0" max="1" step="0.01"></vdr-form-field></div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</vdr-card>